export default __webpack_public_path__ + "static/media/B luik dubbel luik.jpg";